// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ActiveState } from "./active-state";
import { SequenceStepScope } from "./sequence-step-scope";

/**
 * Added v5 — one ordered step in a modifier's expected-message sequence.
 *
 * After the modifier's `payload` is written to the target channel, VTS waits
 * for these steps, in order, on the modifier's observe channel
 * (`ChannelModifier.observe_channel_id`, v7; the target channel when absent).
 * A step is satisfied by a CHANGE in the observed message's state that VTS
 * received at or after the payload write began, never by a level left over
 * from earlier. For BEFORE modifiers the sequence gates the held source
 * message; for INBOUND AFTER modifiers it is observed for logging only.
 *
 * The expected message is stored as the same (content, value) scalar pair
 * the v4 source leaf and the adapter `Key` table use — NOT an `Ln2.Message`
 * union. Unions drop their discriminant on the Go Object-API round-trip
 * (the v4 lesson); scalars are round-trip-safe across Rust/Go/TS.
 */
export class ModifierSequenceStep implements flatbuffers.IUnpackableObject<ModifierSequenceStepT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ModifierSequenceStep {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsModifierSequenceStep(
    bb: flatbuffers.ByteBuffer,
    obj?: ModifierSequenceStep,
  ): ModifierSequenceStep {
    return (obj || new ModifierSequenceStep()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsModifierSequenceStep(
    bb: flatbuffers.ByteBuffer,
    obj?: ModifierSequenceStep,
  ): ModifierSequenceStep {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ModifierSequenceStep()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  /**
   * `MessageContent` discriminant the step waits to observe on the target
   * channel (same discriminant space as `ChannelModifier.source_message_content`;
   * u8 range 0..=9 widened to short). 0 (`MessageContent::NONE`) is invalid
   * for a step and means "unset" — VTS drops a step with content 0.
   */
  expectedMessageContent(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  /**
   * The specific leaf value within that content the step waits to observe
   * (same value space as `ChannelModifier.source_message_value`).
   */
  expectedMessageValue(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  /**
   * Per-step receive timeout in milliseconds. If the expected message is
   * not observed within this budget the gate fails, and the modifier's
   * `timeout_policy` decides the held message's fate (RELEASE by default).
   * Default 2000 ms mirrors the legacy BEFORE ack timeout. Stored as uint
   * (non-negative milliseconds); 0 means "use the runtime default"
   * (VTS `DEFAULT_STEP_TIMEOUT_MS`).
   */
  timeoutMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 2000;
  }

  /**
   * Added v7. The state the observed message must change TO: `ACTIVE`,
   * `INACTIVE`, or `UNSET` (the default) for either. A two-step sequence
   * INACTIVE then ACTIVE waits for a device to go busy and then finish, so
   * the previous action's completion cannot satisfy it.
   */
  expectedActive(): ActiveState {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ActiveState.UNSET;
  }

  /**
   * Added v7. How the observed message's position (and lift) must agree with
   * the payload's. See `SequenceStepScope` in enums.fbs.
   */
  scope(): SequenceStepScope {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : SequenceStepScope.SAME_POSITION;
  }

  static startModifierSequenceStep(builder: flatbuffers.Builder) {
    builder.startObject(5);
  }

  static addExpectedMessageContent(builder: flatbuffers.Builder, expectedMessageContent: number) {
    builder.addFieldInt16(0, expectedMessageContent, 0);
  }

  static addExpectedMessageValue(builder: flatbuffers.Builder, expectedMessageValue: number) {
    builder.addFieldInt32(1, expectedMessageValue, 0);
  }

  static addTimeoutMs(builder: flatbuffers.Builder, timeoutMs: number) {
    builder.addFieldInt32(2, timeoutMs, 2000);
  }

  static addExpectedActive(builder: flatbuffers.Builder, expectedActive: ActiveState) {
    builder.addFieldInt8(3, expectedActive, ActiveState.UNSET);
  }

  static addScope(builder: flatbuffers.Builder, scope: SequenceStepScope) {
    builder.addFieldInt8(4, scope, SequenceStepScope.SAME_POSITION);
  }

  static endModifierSequenceStep(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createModifierSequenceStep(
    builder: flatbuffers.Builder,
    expectedMessageContent: number,
    expectedMessageValue: number,
    timeoutMs: number,
    expectedActive: ActiveState,
    scope: SequenceStepScope,
  ): flatbuffers.Offset {
    ModifierSequenceStep.startModifierSequenceStep(builder);
    ModifierSequenceStep.addExpectedMessageContent(builder, expectedMessageContent);
    ModifierSequenceStep.addExpectedMessageValue(builder, expectedMessageValue);
    ModifierSequenceStep.addTimeoutMs(builder, timeoutMs);
    ModifierSequenceStep.addExpectedActive(builder, expectedActive);
    ModifierSequenceStep.addScope(builder, scope);
    return ModifierSequenceStep.endModifierSequenceStep(builder);
  }

  unpack(): ModifierSequenceStepT {
    return new ModifierSequenceStepT(
      this.expectedMessageContent(),
      this.expectedMessageValue(),
      this.timeoutMs(),
      this.expectedActive(),
      this.scope(),
    );
  }

  unpackTo(_o: ModifierSequenceStepT): void {
    _o.expectedMessageContent = this.expectedMessageContent();
    _o.expectedMessageValue = this.expectedMessageValue();
    _o.timeoutMs = this.timeoutMs();
    _o.expectedActive = this.expectedActive();
    _o.scope = this.scope();
  }

  unpackFields(...fields: string[]): ModifierSequenceStepT {
    const t = new ModifierSequenceStepT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("expected_message_content")) {
      t.expectedMessageContent = this.expectedMessageContent();
    }
    if (fieldSet.has("expected_message_value")) {
      t.expectedMessageValue = this.expectedMessageValue();
    }
    if (fieldSet.has("timeout_ms")) {
      t.timeoutMs = this.timeoutMs();
    }
    if (fieldSet.has("expected_active")) {
      t.expectedActive = this.expectedActive();
    }
    if (fieldSet.has("scope")) {
      t.scope = this.scope();
    }
    return t;
  }
}

export class ModifierSequenceStepT implements flatbuffers.IGeneratedObject {
  constructor(
    public expectedMessageContent: number = 0,
    public expectedMessageValue: number = 0,
    public timeoutMs: number = 2000,
    public expectedActive: ActiveState = ActiveState.UNSET,
    public scope: SequenceStepScope = SequenceStepScope.SAME_POSITION,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return ModifierSequenceStep.createModifierSequenceStep(
      builder,
      this.expectedMessageContent,
      this.expectedMessageValue,
      this.timeoutMs,
      this.expectedActive,
      this.scope,
    );
  }

  clone(): ModifierSequenceStepT {
    const obj = new ModifierSequenceStepT();
    obj.expectedMessageContent = this.expectedMessageContent;
    obj.expectedMessageValue = this.expectedMessageValue;
    obj.timeoutMs = this.timeoutMs;
    obj.expectedActive = this.expectedActive;
    obj.scope = this.scope;
    return obj;
  }

  equals(other: ModifierSequenceStepT): boolean {
    if (this.expectedMessageContent !== other.expectedMessageContent) return false;
    if (this.expectedMessageValue !== other.expectedMessageValue) return false;
    if (this.timeoutMs !== other.timeoutMs) return false;
    if (this.expectedActive !== other.expectedActive) return false;
    if (this.scope !== other.scope) return false;
    return true;
  }
}

export function verifyModifierSequenceStep(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
    verifier.checkScalarField(tablePos, 6, 4);
    verifier.checkScalarField(tablePos, 8, 4);
    verifier.checkScalarField(tablePos, 10, 1);
    verifier.checkScalarField(tablePos, 12, 1);
  } finally {
    verifier.popDepth();
  }
}
